import React from "react";
import { cn } from "../lib/utils";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  density?: number; // pixels per grid step
}

// Subtle tiles/grid background 
export default function Tiles({ className, density = 24, ...props }: Props) {
  const size = Math.max(8, Math.min(64, density));
  const bg = `
    radial-gradient(circle at 1px 1px, rgba(255,255,255,0.08) 1px, transparent 0) 0 0 / ${size}px ${size}px,
    linear-gradient(rgba(255,255,255,0.05), rgba(255,255,255,0.05))
  `;
  return (
    <div
      aria-hidden
      className={cn("pointer-events-none absolute inset-0", className)}
      style={{ background: bg }}
      {...props}
    />
  );
}
